// 示範資料（僅 REACT_APP_VELOPULSE_FIXTURES=1 時載入；內容取自 CEO 核准 Draft v0.1 mocks）
// 正式環境預設關閉：後端未就緒時畫面顯示誠實的「尚未啟用」狀態，不會出現這些資料。

const clone = (v) => JSON.parse(JSON.stringify(v));
const wait = (ms = 250) => new Promise((r) => setTimeout(r, ms));

const moduleLabels = (keys) => (keys || []).map((key) => ({
  key,
  label: key === 'real_estate' ? '賣房（房仲）' : key === 'automotive' ? '賣車（汽車業）' : key,
}));

const orgs = [
  { id: 'org-shengda', name: '盛達汽車貿易', short_name: '盛達汽車', code: 'SD-AUTO', industry: '汽車零售', role: '管理員', org_role: 'org_admin', last_entered_at: '2026-09-20T18:22:00+08:00', modules: ['automotive'], module_labels: moduleLabels(['automotive']) },
  { id: 'org-qinghe', name: '青禾物流', short_name: '青禾物流', code: 'QH-LOG', industry: '物流', role: '營運', org_role: 'member', last_entered_at: '2026-09-14T09:00:00+08:00', modules: ['automotive', 'real_estate'], module_labels: moduleLabels(['automotive', 'real_estate']) },
  { id: 'org-polaris', name: '北極星二手車', short_name: '北極星', code: 'PLS', industry: '汽車零售', role: '業務主管', org_role: 'team_manager', last_entered_at: null, modules: ['automotive'], module_labels: moduleLabels(['automotive']) },
  { id: 'org-xiangyi', name: '翔翼租賃', short_name: '翔翼租賃', code: 'XY-LEASE', industry: '租賃', role: '檢視者', org_role: 'member', last_entered_at: null, modules: ['automotive'], module_labels: moduleLabels(['automotive']) },
];

const platformCompanies = orgs.map((o, i) => ({
  ...o,
  is_active: i !== 3,
  member_count: i === 0 ? 3 : 1,
  created_at: '2026-09-01T00:00:00+08:00',
}));

const roleLabel = (role) => (role === 'org_admin' ? '公司管理員' : role === 'team_manager' ? '團隊主管' : '成員');

const orgMembers = [
  { id: 'u-lin', name: '林經理', email: 'lin@example.com', org_role: 'org_admin', org_role_label: '公司管理員', is_active: true, role: 'staff' },
  { id: 'u-chen', name: '陳專員', email: 'chen@example.com', org_role: 'member', org_role_label: '成員', is_active: true, role: 'staff' },
  { id: 'u-wu', name: '吳主管', email: 'wu@example.com', org_role: 'team_manager', org_role_label: '團隊主管', is_active: true, role: 'manager' },
];

const orgInvites = [
  {
    id: 'inv-demo', email: 'new.rep@example.com', name: '新業務', org_role: 'member', org_role_label: '成員',
    status: 'pending', send_status: 'sent', expires_at: '2026-09-29T00:00:00+08:00',
    invited_by_name: '林經理', last_sent_at: '2026-09-22T09:00:00+08:00', last_send_error: null,
    created_at: '2026-09-22T09:00:00+08:00', _token: 'fixture-invite-token',
  },
];

const fixtureSendInvite = async (id) => {
  await wait();
  const inv = orgInvites.find((x) => x.id === id);
  if (!inv) { const e = new Error('not found'); e.response = { status: 404, data: { error: '邀請連結無效或已過期' } }; throw e; }
  inv.status = 'pending';
  inv.send_status = 'sent';
  inv.last_sent_at = new Date().toISOString();
  inv.last_send_error = null;
  inv._token = inv._token || `fixture-${id}`;
  return clone({
    send: 'sent',
    stubbed: true,
    invite: { ...inv, invite_url: `${window.location.origin}/invite/${inv._token}` },
  });
};

const vehicles = [
  { id: 'v-1042', code: 'VP-1042', type: 'vehicle', brand: 'Toyota', model: 'Camry 2.0', model_year: 2021, exterior_color: '白', mileage: 42100, status: 'available', asking_price: 628000, plate_no: 'BCD-1042', note: '', updated_at: '2026-09-21T09:10:00+08:00' },
  { id: 'v-1038', code: 'VP-1038', type: 'vehicle', brand: 'Honda', model: 'Civic 1.5', model_year: 2019, exterior_color: '灰', mileage: 61800, status: 'preparing', asking_price: 428000, plate_no: 'AYZ-1038', note: '', updated_at: '2026-09-20T15:00:00+08:00' },
  { id: 'v-1031', code: 'VP-1031', type: 'vehicle', brand: 'Toyota', model: 'RAV4', model_year: 2020, exterior_color: '白', mileage: 55200, status: 'reserved', asking_price: 718000, plate_no: 'BFA-1031', note: '', updated_at: '2026-09-20T11:30:00+08:00' },
  { id: 'v-1024', code: 'VP-1024', type: 'vehicle', brand: 'Mazda', model: 'CX-5', model_year: 2018, exterior_color: '紅', mileage: 78400, status: 'available', asking_price: 498000, plate_no: 'AWK-1024', note: '', updated_at: '2026-09-18T10:00:00+08:00' },
  { id: 'v-1019', code: 'VP-1019', type: 'vehicle', brand: 'Benz', model: 'C200', model_year: 2017, exterior_color: '黑', mileage: 92000, status: 'preparing', asking_price: 880000, plate_no: 'ARS-1019', note: '', updated_at: '2026-09-17T10:00:00+08:00' },
];

const activities = {
  'v-1042': [
    { id: 'a1', at: '2026-09-21T09:10:00+08:00', actor: '林經理', text: '更新里程為 42,100' },
    { id: 'a2', at: '2026-09-19T14:00:00+08:00', actor: '王先生', text: '完成試駕（商機 OP-882）' },
    { id: 'a3', at: '2026-09-15T10:00:00+08:00', actor: '系統', text: '車輛入庫並上架' },
  ],
};

const opportunities = [
  { id: 'op-901', code: 'OP-901', title: 'LINE · 詢問白色休旅', summary: '來源：官方帳號 · 尚未指名', stage: 'new', tag: 'LINE', amount: null, customer_name: '匿名', source: 'LINE 官方帳號', owner: '', record_id: null },
  { id: 'op-897', code: 'OP-897', title: '網站表單 · 小李', summary: '想看 50–60 萬轎車', stage: 'new', tag: 'Web', amount: 550000, customer_name: '小李', source: '網站表單', owner: '', record_id: null },
  { id: 'op-882', code: 'OP-882', title: '王先生 · Camry', summary: '關聯 VP-1042 · 已試駕', stage: 'negotiating', tag: '熱', amount: 580000, customer_name: '王先生', source: '門市', owner: '林經理', record_id: 'v-1042' },
  { id: 'op-876', code: 'OP-876', title: '張太太 · Civic', summary: '比價中 · 下週回電', stage: 'negotiating', tag: '跟進', amount: 420000, customer_name: '張太太', source: '門市', owner: '林經理', record_id: 'v-1038' },
  { id: 'op-870', code: 'OP-870', title: '陳小姐 · RAV4', summary: '合約草稿已備 · 賞車 14:30', stage: 'contract', tag: '今日', amount: 710000, customer_name: '陳小姐', source: '介紹', owner: '林經理', record_id: 'v-1031' },
  { id: 'op-851', code: 'OP-851', title: '周先生 · CX-5', summary: '9/12 交車完成', stage: 'won', tag: '完成', amount: 490000, customer_name: '周先生', source: '門市', owner: '林經理', record_id: 'v-1024' },
];

const workbench = {
  headline: '今天有 3 件逾期跟進、2 輛新入庫車輛待上架。',
  headline_short: '3 件逾期 · 今日 14:30 有賞車',
  kpi: { todo_today: 8, overdue: 3, week_forecast_amount: 2860000 },
  focus: [
    { id: 'f1', kind: 'overdue', title: '回電王先生', detail: '關注 Camry 2021 · 商機 #OP-882', meta: '原定昨天 16:00', link: '/opportunities/op-882' },
    { id: 'f2', kind: 'overdue', title: '補傳行照影本', detail: '車輛 VP-1042', meta: '採購流程', link: '/records/v-1042' },
    { id: 'f3', kind: 'today', title: '賞車預約', detail: '陳小姐 · 14:30 展間', meta: '關聯：RAV4 2020', link: '/opportunities/op-870' },
    { id: 'f4', kind: 'done', title: '更新標價', detail: 'Civic 2019 依行情調降 2 萬', meta: '', link: '/records/v-1038' },
  ],
};

const lineWizard = {
  available: true,
  step: 1,
  credentials: { channel_id: '', has_secret: false, has_access_token: false, managed_by_env: false },
  webhook: { verified: false, verified_at: null },
  messages: {
    welcome: '您好！歡迎洽詢盛達汽車。回覆「庫存」查看精選車輛，或直接告訴我們想要的車款與預算。',
    menu: ['看庫存', '預約賞車', '聯絡顧問', '服務據點'],
  },
  test: { last_event_at: null },
  enabled: false,
};

let draftSeq = 1;
const drafts = {};
const money = (n) => (n == null || n === '' ? '（空白）' : `NT$ ${Number(n).toLocaleString('en-US')}`);

const REALTY_SOURCE_NOTE = '此為示範物件資料，並非地政司或實價登錄即時查詢。';
const REALTY_TYPES = { apartment: '公寓', elevator_building: '電梯大樓', house: '透天', studio: '套房', villa: '別墅' };
const REALTY_CITIES = {
  '臺北市': ['中正區', '大同區', '中山區', '松山區', '大安區', '萬華區', '信義區', '士林區', '北投區', '內湖區', '南港區', '文山區'],
  '新北市': ['板橋區', '三重區', '中和區', '永和區', '新莊區', '新店區', '土城區', '蘆洲區', '汐止區', '淡水區', '林口區'],
  '桃園市': ['桃園區', '中壢區', '平鎮區', '八德區', '楊梅區', '蘆竹區'],
  '臺中市': ['西屯區', '北屯區', '南屯區', '北區', '西區', '南區'],
  '臺南市': ['東區', '北區', '中西區', '安平區', '永康區'],
  '高雄市': ['左營區', '鼓山區', '三民區', '苓雅區', '鳳山區', '前鎮區'],
};
const REALTY_SEED = [
  { id: 'rl-101', title: '大安信義計畫三房', city: '臺北市', district: '大安區', address: '復興南路一段 120 巷', property_type: 'elevator_building', price: 32800000, ping: 32.8, age: 8, rooms: '3房2廳2衛', floor: '8/14', description: '近大安森林公園，管理完善，屋況佳。' },
  { id: 'rl-102', title: '中山晴光市場公寓', city: '臺北市', district: '中山區', address: '農安街 45 號', property_type: 'apartment', price: 16800000, ping: 24.5, age: 28, rooms: '2房1廳1衛', floor: '4/5', description: '生活機能佳，適合首購。' },
  { id: 'rl-103', title: '信義區高樓景觀宅', city: '臺北市', district: '信義區', address: '松仁路 88 號', property_type: 'elevator_building', price: 58000000, ping: 46.2, age: 5, rooms: '4房2廳2衛', floor: '22/28', description: '面向台北 101，含車位。' },
  { id: 'rl-201', title: '板橋江翠電梯三房', city: '新北市', district: '板橋區', address: '文化路二段 50 號', property_type: 'elevator_building', price: 18800000, ping: 29.4, age: 10, rooms: '3房2廳2衛', floor: '10/15', description: '近江子翠捷運，學區完整。' },
  { id: 'rl-202', title: '新店央北透天', city: '新北市', district: '新店區', address: '央北二路 8 巷', property_type: 'house', price: 24800000, ping: 52.0, age: 18, rooms: '4房3廳3衛', floor: '整棟 4 層', description: '前後院，停車方便。' },
  { id: 'rl-203', title: '林口A9三房', city: '新北市', district: '林口區', address: '文化三路一段', property_type: 'elevator_building', price: 15600000, ping: 31.1, age: 6, rooms: '3房2廳2衛', floor: '7/18', description: '近三井outlet，新林口重劃區。' },
  { id: 'rl-401', title: '西屯七期四房', city: '臺中市', district: '西屯區', address: '市政路 100 號', property_type: 'elevator_building', price: 29800000, ping: 48.6, age: 7, rooms: '4房2廳2衛', floor: '15/25', description: '近國家歌劇院，含雙車位。' },
  { id: 'rl-402', title: '北屯舊社透天', city: '臺中市', district: '北屯區', address: '昌平路二段', property_type: 'house', price: 17800000, ping: 44.0, age: 22, rooms: '4房2廳3衛', floor: '整棟 3 層', description: '近捷運舊社站，一樓可停車。' },
  { id: 'rl-601', title: '左營高鐵三房', city: '高雄市', district: '左營區', address: '高鐵路 88 號', property_type: 'elevator_building', price: 16800000, ping: 34.5, age: 9, rooms: '3房2廳2衛', floor: '11/20', description: '近高鐵左營站與新光三越。' },
  { id: 'rl-603', title: '鳳山青年路公寓', city: '高雄市', district: '鳳山區', address: '青年路二段', property_type: 'apartment', price: 6800000, ping: 26.4, age: 30, rooms: '3房2廳1衛', floor: '2/5', description: '近捷運鳳山西站，總價親民。' },
];

function realtyMeta() {
  return {
    cities: Object.entries(REALTY_CITIES).map(([city, districts]) => ({ city, districts })),
    types: Object.entries(REALTY_TYPES).map(([key, label]) => ({ key, label })),
  };
}
function presentListing(row) {
  return { ...row, property_type_label: REALTY_TYPES[row.property_type] || row.property_type, is_mock: true };
}
function fixtureSearchListings(q = {}) {
  const city = q.city || '';
  const district = q.district || '';
  const type = q.type || '';
  if (type && !REALTY_TYPES[type]) return { error: '物件類型不正確。' };
  if (city && !REALTY_CITIES[city]) return { error: '縣市不正確。' };
  const items = REALTY_SEED.filter((i) => {
    if (city && i.city !== city) return false;
    if (district && i.district !== district) return false;
    if (type && i.property_type !== type) return false;
    if (q.price_min != null && i.price < Number(q.price_min)) return false;
    if (q.price_max != null && i.price > Number(q.price_max)) return false;
    if (q.ping_min != null && i.ping < Number(q.ping_min)) return false;
    if (q.ping_max != null && i.ping > Number(q.ping_max)) return false;
    if (q.age_max != null && i.age > Number(q.age_max)) return false;
    return true;
  }).map(presentListing);
  return {
    source: 'mock', source_note: REALTY_SOURCE_NOTE, items,
    total: REALTY_SEED.length, matched: items.length,
    filters: q, meta: realtyMeta(),
  };
}
function fixtureEstimateTax(input) {
  if (!input || typeof input !== 'object') return { error: '請提供試算資料。' };
  const parseDate = (v, label) => {
    if (typeof v !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(v)) return { error: `請填寫有效的${label}（YYYY-MM-DD）。` };
    const [y, m, d] = v.split('-').map(Number);
    const dt = new Date(Date.UTC(y, m - 1, d));
    if (dt.getUTCFullYear() !== y || dt.getUTCMonth() !== m - 1 || dt.getUTCDate() !== d) return { error: `${label}不是有效日期。` };
    return { value: dt, iso: v };
  };
  const parseMoney = (v, label, required = true) => {
    if (v === undefined || v === null || v === '') return required ? { error: `請填寫${label}。` } : { value: 0 };
    const n = Number(String(v).replace(/,/g, ''));
    if (!Number.isFinite(n) || n < 0) return { error: `${label}須為 0 或正數。` };
    return { value: Math.round(n) };
  };
  const acq = parseDate(input.acquisition_date, '取得日'); if (acq.error) return acq;
  const xfer = parseDate(input.transfer_date, '移轉日'); if (xfer.error) return xfer;
  if (xfer.value < acq.value) return { error: '移轉日不可早於取得日。' };
  const sale = parseMoney(input.sale_price, '成交價'); if (sale.error) return sale;
  const cost = parseMoney(input.cost, '取得成本'); if (cost.error) return cost;
  const expenses = parseMoney(input.expenses, '必要費用', false); if (expenses.error) return expenses;
  const selfUse = !!input.self_use;
  const daysHeld = Math.round((xfer.value - acq.value) / 86400000);
  const yearsHeld = Math.round((daysHeld / 365) * 1000) / 1000;
  const bands = [
    { key: 'under_2', min: 0, max: 2, rate: 0.45, label: '持有未滿 2 年' },
    { key: '2_to_5', min: 2, max: 5, rate: 0.35, label: '持有 2 年以上未滿 5 年' },
    { key: '5_to_10', min: 5, max: 10, rate: 0.20, label: '持有 5 年以上未滿 10 年' },
    { key: 'over_10', min: 10, max: Infinity, rate: 0.15, label: '持有 10 年以上' },
  ];
  const band = bands.find((b) => yearsHeld >= b.min && yearsHeld < b.max) || bands[3];
  const profit = sale.value - cost.value - expenses.value;
  const notes = [];
  let rate = band.rate; let rateLabel = `${Math.round(band.rate * 100)}%（${band.label}）`;
  let exemption = 0; let taxableIncome = Math.max(0, profit); let holdBand = band.key; let selfUseApplied = false;
  if (selfUse && yearsHeld < 6) notes.push('已勾選自住要件，但持有未滿 6 年，無法適用自住優惠，改以一般稅率計算。');
  if (selfUse && yearsHeld >= 6) {
    selfUseApplied = true; rate = 0.10; holdBand = 'self_use'; rateLabel = '10%（自住優惠）';
    exemption = Math.min(Math.max(profit, 0), 4_000_000);
    taxableIncome = Math.max(0, profit - 4_000_000);
  }
  if (profit <= 0) notes.push('成交價低於或等於成本與費用，試算無應稅所得。');
  const taxAmount = Math.round(taxableIncome * rate);
  return {
    tax_amount: taxAmount, rate, rate_percent: Math.round(rate * 100), rate_label: rateLabel,
    years_held: yearsHeld, days_held: daysHeld, hold_band: holdBand,
    hold_band_label: selfUseApplied ? '自住優惠（持有滿 6 年）' : band.label,
    self_use_requested: selfUse, self_use_applied: selfUseApplied,
    breakdown: { sale_price: sale.value, cost: cost.value, expenses: expenses.value, profit, exemption, taxable_income: taxableIncome, rate, tax_amount: taxAmount },
    inputs: { acquisition_date: acq.iso, transfer_date: xfer.iso, self_use: selfUse },
    notes, disclaimer: '試算僅供參考，非正式核定',
  };
}

function buildDraft(text, org) {
  const upd = text.match(/(VP-\d+)/i);
  const price = text.match(/(\d{5,8})/);
  const note = text.match(/[「"“]([^」"”]+)[」"”]/);
  if (upd && (price || note)) {
    const v = vehicles.find((x) => x.code.toLowerCase() === upd[1].toLowerCase());
    if (!v) return null;
    const changes = [];
    if (price) changes.push({ field: 'asking_price', label: '標價', before: money(v.asking_price), after: money(price[1]), value: Number(price[1]) });
    if (note) changes.push({ field: 'note', label: '內部備註', before: v.note || '（空白）', after: note[1], value: note[1] });
    return { action: 'update', summary: `更新車輛 ${v.code}`, title: '草稿：更新車輛紀錄', target: { type: 'vehicle', type_label: '車輛庫存', id: v.id, code: v.code }, changes };
  }
  if (/建立|新增/.test(text) && /商機/.test(text)) {
    return {
      action: 'create', summary: '建立一筆商機', title: '草稿：建立商機', target: { type: 'opportunity', type_label: '商機', id: null, code: '（新）' },
      changes: [
        { field: 'title', label: '名稱', before: '—', after: '新商機', value: '新商機' },
        { field: 'stage', label: '階段', before: '—', after: '新進線', value: 'new' },
      ],
    };
  }
  return null;
}

export const fixtures = {
  async listOrgs() { await wait(); return clone(orgs); },
  async getWorkbench() {
    await wait();
    return { ...clone(workbench), opportunities: clone(opportunities.filter((o) => ['negotiating', 'new', 'contract'].includes(o.stage)).slice(0, 3)), records: clone(vehicles.slice(0, 3)) };
  },
  async listRecords({ q, status, sort } = {}) {
    await wait();
    let rows = clone(vehicles);
    if (q) rows = rows.filter((r) => `${r.code} ${r.brand} ${r.model} ${r.plate_no}`.toLowerCase().includes(q.toLowerCase()));
    if (status) rows = rows.filter((r) => r.status === status);
    if (sort === 'price_desc') rows.sort((a, b) => b.asking_price - a.asking_price);
    return rows;
  },
  async getRecord(id) {
    await wait();
    const r = vehicles.find((v) => v.id === id);
    if (!r) { const e = new Error('not found'); e.response = { status: 404 }; throw e; }
    return { ...clone(r), activities: clone(activities[id] || []), opportunities: clone(opportunities.filter((o) => o.record_id === id)) };
  },
  async updateRecord(id, patch) {
    await wait();
    const r = vehicles.find((v) => v.id === id);
    Object.assign(r, patch, { updated_at: new Date().toISOString() });
    return clone(r);
  },
  async createRecord(data) {
    await wait();
    const n = 1043 + vehicles.length;
    const r = { id: `v-${n}`, code: `VP-${n}`, type: 'vehicle', status: 'preparing', note: '', ...data, updated_at: new Date().toISOString() };
    vehicles.unshift(r);
    return clone(r);
  },
  async listOpportunities() { await wait(); return clone(opportunities); },
  async getOpportunity(id) {
    await wait();
    const o = opportunities.find((x) => x.id === id);
    if (!o) { const e = new Error('not found'); e.response = { status: 404 }; throw e; }
    const rec = vehicles.find((v) => v.id === o.record_id || (o.item_type === 'vehicle' && o.item_id === v.id));
    const listing = o.item_type === 'realty' ? REALTY_SEED.find((x) => x.id === o.item_id) : null;
    return {
      ...clone(o),
      record: rec ? clone(rec) : null,
      listing: listing ? clone(presentListing(listing)) : null,
      activities: [],
    };
  },
  async searchCatalog({ q, type } = {}) {
    await wait(150);
    const needle = String(q || '').trim().toLowerCase();
    const out = [];
    if (!type || type === 'vehicle') {
      out.push(...vehicles
        .filter((v) => !needle || `${v.code} ${v.brand} ${v.model} ${v.plate_no}`.toLowerCase().includes(needle))
        .map((v) => ({
          type: 'vehicle',
          id: v.id,
          code: v.code,
          label: [v.brand, v.model].filter(Boolean).join(' '),
          subtitle: [v.code, v.plate_no, v.model_year].filter(Boolean).join(' · '),
          amount: v.asking_price ?? null,
        })));
    }
    if (!type || type === 'realty') {
      out.push(...REALTY_SEED
        .filter((r) => !needle || `${r.title} ${r.city} ${r.district} ${r.address || ''}`.toLowerCase().includes(needle))
        .map((r) => ({
          type: 'realty',
          id: r.id,
          code: null,
          label: r.title,
          subtitle: [r.city, r.district, REALTY_TYPES[r.property_type] || r.property_type].filter(Boolean).join(' · '),
          amount: r.price ?? null,
        })));
    }
    return clone(out.slice(0, 30));
  },
  async createOpportunity(data) {
    await wait();
    const n = 902 + opportunities.length;
    const o = { id: `op-${n}`, code: `OP-${n}`, stage: 'new', tag: '', summary: '', amount: null, record_id: null, owner: '', source: '手動建立', ...data };
    opportunities.unshift(o);
    return clone(o);
  },
  async moveOpportunity(id, stage) {
    await wait(150);
    const o = opportunities.find((x) => x.id === id);
    o.stage = stage;
    return clone(o);
  },
  async getLineWizard() { await wait(); return clone(lineWizard); },
  async saveLineWizard(step, payload) {
    await wait();
    if (step === 1) lineWizard.credentials = { channel_id: payload.channel_id, has_secret: !!payload.channel_secret, has_access_token: !!payload.access_token, managed_by_env: false };
    if (step === 2) lineWizard.webhook = { verified: true, verified_at: new Date().toISOString(), manual: !!payload.manual };
    if (step === 3) lineWizard.messages = { welcome: payload.welcome, menu: payload.menu };
    lineWizard.step = Math.max(lineWizard.step, Math.min(step + 1, 4));
    return clone(lineWizard);
  },
  async probeLineWebhook() { await wait(600); return { ok: true }; },
  async getLineTestStatus() { await wait(); lineWizard.test.last_event_at = new Date(Date.now() - 2000).toISOString(); return clone(lineWizard.test); },
  async enableLineBot() { await wait(); lineWizard.enabled = true; return clone(lineWizard); },
  async getAssistantStatus() { await wait(100); return { enabled: true }; },
  async sendAssistantMessage(text, org) {
    await wait(500);
    if (/號牌|可領牌|監理站|選號/.test(text) && !/改成|VP-|更新/.test(text)) {
      return {
        reply: '（示範模式）以下是示範號碼，不是監理站今日可領號牌。\n臺北市區監理所・自用小客車\n範-taipei-city-1001（網路選號示意）',
        sources: [{ label: '開啟號牌查詢', link: '/auto/plates' }],
        web_sources: [{ title: '監理服務網', url: 'https://www.mvdis.gov.tw/' }],
      };
    }
    const d = buildDraft(text, org);
    if (d) {
      const id = `draft-${draftSeq++}`;
      drafts[id] = { id, status: 'pending', org_id: org?.id, org_name: org?.name, sends_to_customer: false, ...d };
      return { reply: `了解。我已準備一筆草稿，請核對後確認。目標組織：${org?.name || ''}。`, draft: clone(drafts[id]) };
    }
    if (/白色.*休旅|休旅.*白/.test(text)) {
      return { reply: '查詢結果（僅讀，無需確認）：上架中的白色休旅有 1 輛——Toyota RAV4 2020（VP-1031，NT$ 718,000）。', sources: [{ label: '開啟紀錄 VP-1031', link: '/records/v-1031' }] };
    }
    return { reply: '（示範模式）我可以示範：「把 Camry VP-1042 的標價改成 608000，並加註「週末促銷」」、「幫我建立一筆商機」、「目前有幾輛白色休旅上架中？」' };
  },
  async updateDraft(id, changes) {
    await wait(150);
    drafts[id].changes = changes.map((c) => (c.field === 'asking_price'
      ? { ...c, value: Number(c.value), after: money(c.value) }
      : { ...c, after: String(c.value) }));
    return clone(drafts[id]);
  },
  async confirmDraft(id) {
    await wait(400);
    const d = drafts[id];
    if (d.target.type === 'vehicle' && d.action === 'update') {
      const v = vehicles.find((x) => x.id === d.target.id);
      d.changes.forEach((c) => { v[c.field] = c.value; });
      v.updated_at = new Date().toISOString();
    }
    if (d.target.type === 'opportunity' && d.action === 'create') {
      const data = {};
      d.changes.forEach((c) => { data[c.field] = c.value; });
      const o = await fixtures.createOpportunity(data);
      d.target.id = o.id; d.target.code = o.code;
    }
    d.status = 'confirmed';
    return clone(d);
  },
  async discardDraft(id) { await wait(150); drafts[id].status = 'discarded'; return clone(drafts[id]); },

  async estimateRealtyTax(payload) {
    await wait(200);
    const r = fixtureEstimateTax(payload);
    if (r.error) {
      const err = new Error(r.error);
      err.response = { status: 400, data: { error: r.error } };
      throw err;
    }
    return r;
  },
  async listRealtyListings(params = {}) {
    await wait(200);
    const r = fixtureSearchListings(params);
    if (r.error) {
      const err = new Error(r.error);
      err.response = { status: 400, data: { error: r.error } };
      throw err;
    }
    return clone(r);
  },
  async getRealtyListing(id) {
    await wait(150);
    const item = REALTY_SEED.find((x) => x.id === id);
    if (!item) {
      const err = new Error('找不到這筆物件');
      err.response = { status: 404, data: { error: '找不到這筆物件，可能已被移除或不屬於目前組織。' } };
      throw err;
    }
    return clone({ ...presentListing(item), photos: [], source_note: REALTY_SOURCE_NOTE, meta: realtyMeta() });
  },
  async downloadRealtyImportTemplate() {
    await wait(80);
    const csv = '\uFEFFtitle,city,district,address,property_type,price,ping,age,rooms,floor,description\n示範物件,臺北市,大安區,,電梯大樓,32800000,32.8,8,3房2廳2衛,8/14,範例\n';
    return { data: new Blob([csv], { type: 'text/csv;charset=utf-8' }) };
  },
  async importRealtyListings() {
    await wait(200);
    return { imported: 0, failed: 0, errors: [], message: '示範模式不寫入資料庫。這是貴公司自有物件匯入，不是外站爬蟲。' };
  },
  async createRealtyListing(payload) {
    await wait(150);
    return clone({ id: 'rl-new', ...payload, is_mock: false, photos: [], source_note: REALTY_SOURCE_NOTE, meta: realtyMeta() });
  },
  async addRealtyListingPhoto(id, { url } = {}) {
    await wait(150);
    return { id: `ph-${Date.now()}`, url: url || 'https://example.com/demo.jpg', sort_order: 0 };
  },
  async deleteRealtyListingPhoto() {
    await wait(100);
    return { ok: true };
  },
  async uploadImage() {
    await wait(100);
    return { url: 'https://example.com/demo.jpg', filename: 'demo.jpg', size: 1 };
  },

  async getPlateMeta() {
    await wait(120);
    return {
      provider: 'mock',
      disclaimer: '示範或降級結果僅供介面與流程使用，不是監理站當日可領號牌，不能作為領牌或選號依據。',
      compliance: '未呼叫監理服務網。',
      directory_note: '監理站名稱是公開機關名錄的靜態整理。',
      cities: ['臺北市', '新北市', '臺中市', '高雄市'],
      stations: [
        { id: 'taipei-city', name: '臺北市區監理所', cities: ['臺北市'], primary_city: '臺北市', default_for_city: true },
        { id: 'taipei', name: '臺北區監理所', cities: ['新北市'], primary_city: '新北市', default_for_city: true },
        { id: 'taichung', name: '臺中區監理所', cities: ['臺中市'], primary_city: '臺中市', default_for_city: true },
        { id: 'kaohsiung-city', name: '高雄市區監理所', cities: ['高雄市'], primary_city: '高雄市', default_for_city: true },
      ],
      vehicle_types: [
        { id: 'car_private', label: '自用小客車' },
        { id: 'car_private_truck', label: '自用小貨車' },
        { id: 'car_ev_private', label: '電動自用小客車' },
        { id: 'moto_heavy', label: '普通重型機車' },
      ],
      sources: [{ title: '監理服務網', url: 'https://www.mvdis.gov.tw/', note: '網頁入口，不是開放 API。' }],
    };
  },
  async lookupPlate(payload = {}) {
    await wait(200);
    if (!payload.vehicle_type) {
      const err = new Error('請選擇車輛種類。');
      err.response = { status: 400, data: { error: '請選擇車輛種類。' } };
      throw err;
    }
    if (!payload.city && !payload.station_id) {
      const err = new Error('請選擇縣市或監理站。');
      err.response = { status: 400, data: { error: '請選擇縣市或監理站。' } };
      throw err;
    }
    const stationName = payload.city === '高雄市' ? '高雄市區監理所' : '臺北市區監理所';
    return {
      ok: true,
      degraded: false,
      status: 'mock',
      provider: 'mock',
      is_mock: true,
      query: {
        city: payload.city || '臺北市',
        station_id: payload.station_id || 'taipei-city',
        station_name: stationName,
        vehicle_type: payload.vehicle_type,
        vehicle_type_label: '自用小客車',
        query_date: payload.query_date || '2026-09-22',
        period: (payload.query_date || '2026-09-22').slice(0, 7),
        station_inferred: !payload.station_id,
      },
      plates: [
        { number: '範-taipei-city-1024', kind: '網路選號示意', status: 'sample', available: null, note: '示範號碼，並非監理站當日可領號牌' },
        { number: '範-taipei-city-2048', kind: '順號編發示意', status: 'sample', available: null, note: '示範號碼，並非監理站當日可領號牌' },
      ],
      message: '目前使用示範號牌來源。這些號碼不能拿去選號或領牌。',
      disclaimer: '示範或降級結果僅供介面與流程使用，不是監理站當日可領號牌，不能作為領牌或選號依據。',
      sources: [{ title: '監理服務網', url: 'https://www.mvdis.gov.tw/' }],
    };
  },

  async listOrgMembers(params = {}) {
    await wait();
    const q = String(params.q || '').trim().toLowerCase();
    return clone(orgMembers.filter((m) => {
      if (q && !(`${m.name} ${m.email}`.toLowerCase().includes(q))) return false;
      if (params.org_role && m.org_role !== params.org_role) return false;
      if (params.status === 'active' && m.is_active === false) return false;
      if (params.status === 'inactive' && m.is_active !== false) return false;
      return true;
    }));
  },
  async createOrgMember(payload) {
    await wait();
    const m = {
      id: `u-${Date.now()}`,
      name: payload.name,
      email: payload.email,
      org_role: payload.org_role || 'member',
      org_role_label: roleLabel(payload.org_role),
      is_active: true,
      role: 'staff',
    };
    orgMembers.unshift(m);
    return clone(m);
  },
  async updateOrgMember(id, patch) {
    await wait();
    const m = orgMembers.find((x) => x.id === id);
    if (!m) { const e = new Error('not found'); e.response = { status: 404, data: { error: '使用者不存在' } }; throw e; }
    Object.assign(m, patch);
    if (patch.org_role) m.org_role_label = roleLabel(patch.org_role);
    return clone(m);
  },
  async setOrgMemberStatus(id, is_active) {
    await wait();
    const m = orgMembers.find((x) => x.id === id);
    if (!m) { const e = new Error('not found'); e.response = { status: 404, data: { error: '使用者不存在' } }; throw e; }
    m.is_active = is_active;
    return clone(m);
  },
  async toggleOrgMember(id) {
    await wait();
    const m = orgMembers.find((x) => x.id === id);
    if (!m) { const e = new Error('not found'); e.response = { status: 404, data: { error: '使用者不存在' } }; throw e; }
    m.is_active = !m.is_active;
    return clone(m);
  },
  async getOrgOverview() {
    await wait();
    return clone({
      profile: { ...orgs[0], slug: 'shengda', is_active: true, org_role: 'org_admin', org_role_label: '公司管理員' },
      counts: { members: orgMembers.length, active: orgMembers.filter((m) => m.is_active !== false).length, admins: 1, pending_invites: 1 },
      invites_error: null,
      modules: orgs[0].modules,
      module_labels: orgs[0].module_labels,
    });
  },
  async getPlatformMe() {
    await wait();
    return { is_platform_admin: true };
  },
  async listPlatformCompanies(params = {}) {
    await wait();
    const q = String(params.q || '').trim().toLowerCase();
    return clone(platformCompanies.filter((c) => !q || c.name.toLowerCase().includes(q)));
  },
  async getPlatformCompany(id) {
    await wait();
    const c = platformCompanies.find((x) => x.id === id);
    if (!c) { const e = new Error('not found'); e.response = { status: 404, data: { error: '找不到這家公司' } }; throw e; }
    return clone(c);
  },
  async createPlatformCompany(payload) {
    await wait();
    const modules = payload.modules || [];
    const c = {
      id: `org-${Date.now()}`,
      name: payload.name,
      short_name: payload.short_name || payload.name,
      code: payload.code || 'NEW',
      industry: payload.industry || '',
      is_active: true,
      member_count: payload.admin_email ? 1 : 0,
      created_at: new Date().toISOString(),
      modules,
      module_labels: moduleLabels(modules),
    };
    platformCompanies.unshift(c);
    return clone(c);
  },
  async updatePlatformCompany(id, payload) {
    await wait();
    const c = platformCompanies.find((x) => x.id === id);
    if (!c) { const e = new Error('not found'); e.response = { status: 404, data: { error: '找不到這家公司' } }; throw e; }
    Object.assign(c, payload);
    if (payload.modules) c.module_labels = moduleLabels(payload.modules);
    return clone(c);
  },
  async listPlatformCompanyMembers(id, params = {}) {
    await wait();
    const c = platformCompanies.find((x) => x.id === id);
    if (!c) { const e = new Error('not found'); e.response = { status: 404, data: { error: '找不到這家公司' } }; throw e; }
    let list = id === 'org-shengda' ? orgMembers : orgMembers.slice(0, 1);
    const q = String(params.q || '').trim().toLowerCase();
    if (q) list = list.filter((m) => `${m.name} ${m.email}`.toLowerCase().includes(q));
    if (params.org_role) list = list.filter((m) => m.org_role === params.org_role);
    if (params.status === 'active') list = list.filter((m) => m.is_active !== false);
    if (params.status === 'inactive') list = list.filter((m) => m.is_active === false);
    return clone(list);
  },
  async addPlatformCompanyMember(id, payload) {
    await wait();
    const email = String(payload.email || '').trim().toLowerCase();
    const existing = orgMembers.find((m) => m.email.toLowerCase() === email);
    if (existing) {
      const e = new Error('此 Email 已是本公司成員');
      e.response = { status: 409, data: { error: '此 Email 已是本公司成員' } };
      throw e;
    }
    const m = {
      id: `u-${Date.now()}`,
      name: email.split('@')[0],
      email,
      org_role: payload.org_role || 'member',
      org_role_label: roleLabel(payload.org_role || 'member'),
      is_active: true,
      role: 'staff',
    };
    orgMembers.push(m);
    const c = platformCompanies.find((x) => x.id === id);
    if (c) c.member_count = (c.member_count || 0) + 1;
    return clone(m);
  },
  async updatePlatformCompanyMember(companyId, userId, payload) {
    await wait();
    const m = orgMembers.find((x) => x.id === userId);
    if (!m) { const e = new Error('not found'); e.response = { status: 404, data: { error: '使用者不存在' } }; throw e; }
    if (payload.org_role) {
      m.org_role = payload.org_role;
      m.org_role_label = roleLabel(payload.org_role);
    }
    return clone(m);
  },
  async setPlatformCompanyMemberStatus(companyId, userId, is_active) {
    await wait();
    const m = orgMembers.find((x) => x.id === userId);
    if (!m) { const e = new Error('not found'); e.response = { status: 404, data: { error: '使用者不存在' } }; throw e; }
    m.is_active = is_active;
    return clone(m);
  },
  async getOrgProfile() {
    await wait();
    return clone({ ...orgs[0], slug: 'shengda', is_active: true, org_role: 'org_admin', org_role_label: '公司管理員' });
  },
  async updateOrgProfile(payload) {
    await wait();
    Object.assign(orgs[0], payload);
    return clone({ ...orgs[0], slug: 'shengda', is_active: true, org_role: 'org_admin', org_role_label: '公司管理員' });
  },
  async listOrgInvites(params = {}) {
    await wait();
    const q = String(params.q || '').trim().toLowerCase();
    return clone(orgInvites.filter((i) => {
      if (q && !(`${i.email} ${i.name || ''}`.toLowerCase().includes(q))) return false;
      if (params.status === 'open') return ['draft', 'sent', 'failed', 'pending'].includes(i.status);
      if (params.status && i.status !== params.status) return false;
      return true;
    }));
  },
  async createOrgInvite(payload) {
    await wait();
    const email = String(payload.email || '').trim().toLowerCase();
    if (orgMembers.some((m) => m.email.toLowerCase() === email)) {
      const e = new Error('此 Email 已是本公司成員');
      e.response = { status: 409, data: { error: '此 Email 已是本公司成員' } };
      throw e;
    }
    const open = orgInvites.find((i) => i.email === email && ['draft', 'failed', 'pending'].includes(i.status));
    if (open) return clone({ ...open, idempotent: true });
    const inv = {
      id: `inv-${Date.now()}`,
      email,
      name: payload.name || '',
      org_role: payload.org_role || 'member',
      org_role_label: roleLabel(payload.org_role),
      status: 'draft',
      send_status: null,
      expires_at: new Date(Date.now() + 7 * 86400000).toISOString(),
      invited_by_name: '林經理',
      last_sent_at: null,
      last_send_error: null,
      created_at: new Date().toISOString(),
    };
    orgInvites.unshift(inv);
    return clone(inv);
  },
  async sendOrgInvite(id) { return fixtureSendInvite(id); },
  async resendOrgInvite(id) { return fixtureSendInvite(id); },
  async revokeOrgInvite(id) {
    await wait();
    const inv = orgInvites.find((x) => x.id === id);
    if (!inv) { const e = new Error('not found'); e.response = { status: 404, data: { error: '邀請連結無效或已過期' } }; throw e; }
    inv.status = 'revoked';
    return clone(inv);
  },
  async previewInvite(token) {
    await wait();
    const inv = orgInvites.find((x) => x._token === token);
    if (!inv || !['pending', 'sent'].includes(inv.status)) {
      const e = new Error('邀請連結無效或已過期');
      e.response = { status: 404, data: { error: '邀請連結無效或已過期' } };
      throw e;
    }
    return clone({
      org_name: orgs[0].name,
      email: inv.email,
      org_role: inv.org_role,
      org_role_label: inv.org_role_label,
      expires_at: inv.expires_at,
      existing_user: Boolean(inv._existing),
      status: inv.status,
    });
  },
  async acceptInvite(token, payload = {}) {
    await wait();
    const inv = orgInvites.find((x) => x._token === token);
    if (!inv || !['pending', 'sent'].includes(inv.status)) {
      const e = new Error('邀請連結無效或已過期');
      e.response = { status: 404, data: { error: '邀請連結無效或已過期' } };
      throw e;
    }
    inv.status = 'accepted';
    inv.accepted_at = new Date().toISOString();
    if (!inv._existing) {
      orgMembers.unshift({
        id: `u-${Date.now()}`,
        name: payload.name || inv.name || inv.email,
        email: inv.email,
        org_role: inv.org_role,
        org_role_label: inv.org_role_label,
        is_active: true,
        role: 'staff',
      });
    }
    return clone({
      already_member: Boolean(inv._existing),
      created_user: !inv._existing,
      org: orgs[0],
      user: { id: 'u-new', name: payload.name || inv.name || '新成員', email: inv.email, role: 'staff', permissions: [] },
      token: 'fixture-invite',
    });
  },
};
